import React from 'react';
import { Heart, Instagram, Mail } from 'lucide-react';
const Footer = () => {
  return <footer className="bg-champagne bg-opacity-30 py-12" data-id="element-51">
      <div className="max-w-5xl mx-auto px-4 text-center" data-id="element-52">
        <h2 className="font-serif text-3xl mb-2 text-gray-800" data-id="element-53">
          Ayevbosa & Abiodun
        </h2>
        <p className="text-gray-700 mb-6" data-id="element-54">February 14, 2026 • Lagos State</p>
        <div className="w-16 h-0.5 bg-gold mx-auto mb-6" data-id="element-55"></div>
        <div className="flex justify-center space-x-6 mb-8" data-id="element-56">
          <a href="#" className="text-gray-600 hover:text-gold transition-colors" data-id="element-57">
            <Instagram size={24} data-id="element-58" />
          </a>
          <a href="mailto:ayevbosa.abiodun@example.com" className="text-gray-600 hover:text-gold transition-colors" data-id="element-59">
            <Mail size={24} data-id="element-60" />
          </a>
        </div>
        <p className="text-gray-600 flex items-center justify-center text-sm" data-id="element-61">
          Made with <Heart size={14} className="text-gold mx-1" data-id="element-62" /> for our
          special day
        </p>
      </div>
    </footer>;
};
export default Footer;